// extracted by mini-css-extract-plugin
export default {"rule-status":"RegraDePrecoTag_rule-status__+bcGN","ACTIVE":"RegraDePrecoTag_ACTIVE__Q0lR9","EXPIRED":"RegraDePrecoTag_EXPIRED__Si0fq"};